/**
 * SQL built-in function names for Databricks SQL
 * This file contains all SQL functions that should be available in autocomplete
 * but are not keywords in the ANTLR lexer (they're parsed as identifiers).
 */

export const BUILT_IN_FUNCTION_NAMES: string[] = [
  'ABS',
  'ACOS',
  'ACOSH',
  'ADD_MONTHS',
  'AES_DECRYPT',
  'AES_ENCRYPT',
  'AGGREGATE',
  'AI_ANALYZE_SENTIMENT',
  'AI_CLASSIFY',
  'AI_EXTRACT',
  'AI_FIX_GRAMMAR',
  'AI_FORECAST',
  'AI_GEN',
  'AI_GENERATE_TEXT',
  'AI_MASK',
  'AI_QUERY',
  'AI_SIMILARITY',
  'AI_SUMMARIZE',
  'AI_TRANSLATE',
  'ANY',
  'ANY_VALUE',
  'APPROX_COUNT_DISTINCT',
  'APPROX_PERCENTILE',
  'APPROX_TOP_K',
  'ARRAY',
  'ARRAY_AGG',
  'ARRAY_APPEND',
  'ARRAY_COMPACT',
  'ARRAY_CONTAINS',
  'ARRAY_DISTINCT',
  'ARRAY_EXCEPT',
  'ARRAY_INSERT',
  'ARRAY_INTERSECT',
  'ARRAY_JOIN',
  'ARRAY_MAX',
  'ARRAY_MIN',
  'ARRAY_POSITION',
  'ARRAY_PREPEND',
  'ARRAY_REMOVE',
  'ARRAY_REPEAT',
  'ARRAY_SIZE',
  'ARRAY_SORT',
  'ARRAY_UNION',
  'ARRAYS_OVERLAP',
  'ARRAYS_ZIP',
  'ASCII',
  'ASIN',
  'ASINH',
  'ASSERT_TRUE',
  'ATAN',
  'ATAN2',
  'ATANH',
  'AVG',
  'BASE64',
  'BIGINT',
  'BIN',
  'BINARY',
  'BIT_AND',
  'BIT_COUNT',
  'BIT_GET',
  'BIT_LENGTH',
  'BIT_OR',
  'BIT_REVERSE',
  'BIT_XOR',
  'BITMAP_BIT_POSITION',
  'BITMAP_BUCKET_NUMBER',
  'BITMAP_CONSTRUCT_AGG',
  'BITMAP_COUNT',
  'BITMAP_OR_AGG',
  'BOOL_AND',
  'BOOL_OR',
  'BOOLEAN',
  'BROUND',
  'BTRIM',
  'CARDINALITY',
  'CAST',
  'CBRT',
  'CEIL',
  'CEILING',
  'CHAR',
  'CHAR_LENGTH',
  'CHARACTER_LENGTH',
  'CHARINDEX',
  'CHR',
  'COALESCE',
  'COLLATIONS',
  'COLLECT_LIST',
  'COLLECT_SET',
  'CONCAT',
  'CONCAT_WS',
  'CONTAINS',
  'CONV',
  'CONVERT_TIMEZONE',
  'CORR',
  'COS',
  'COSH',
  'COT',
  'COUNT',
  'COUNT_IF',
  'COUNT_MIN_SKETCH',
  'COVAR_POP',
  'COVAR_SAMP',
  'CRC32',
  'CSC',
  'CUBE',
  'CUME_DIST',
  'CURDATE',
  'CURRENT_CATALOG',
  'CURRENT_DATABASE',
  'CURRENT_DATE',
  'CURRENT_METASTORE',
  'CURRENT_RECIPIENT',
  'CURRENT_SCHEMA',
  'CURRENT_TIMESTAMP',
  'CURRENT_TIMEZONE',
  'CURRENT_USER',
  'CURRENT_VERSION',
  'DATE',
  'DATE_ADD',
  'DATE_DIFF',
  'DATE_FORMAT',
  'DATE_FROM_UNIX_DATE',
  'DATE_PART',
  'DATE_SUB',
  'DATE_TRUNC',
  'DATEADD',
  'DATEDIFF',
  'DAY',
  'DAYNAME',
  'DAYOFMONTH',
  'DAYOFWEEK',
  'DAYOFYEAR',
  'DECIMAL',
  'DECODE',
  'DEGREES',
  'DENSE_RANK',
  'DOUBLE',
  'E',
  'ELEMENT_AT',
  'ELT',
  'ENCODE',
  'ENDSWITH',
  'EQUAL_NULL',
  'EVERY',
  'EXISTS',
  'EXP',
  'EXPLODE',
  'EXPLODE_OUTER',
  'EXPM1',
  'EXTRACT',
  'FACTORIAL',
  'FILTER',
  'FIND_IN_SET',
  'FIRST',
  'FIRST_VALUE',
  'FLATTEN',
  'FLOAT',
  'FLOOR',
  'FORALL',
  'FORMAT_NUMBER',
  'FORMAT_STRING',
  'FROM_AVRO',
  'FROM_CSV',
  'FROM_JSON',
  'FROM_UNIXTIME',
  'FROM_UTC_TIMESTAMP',
  'FROM_XML',
  'GET',
  'GET_JSON_OBJECT',
  'GETBIT',
  'GETDATE',
  'GREATEST',
  'GROUPING',
  'GROUPING_ID',
  'H3_BOUNDARYASGEOJSON',
  'H3_BOUNDARYASWKB',
  'H3_BOUNDARYASWKT',
  'H3_CENTERASGEOJSON',
  'H3_CENTERASWKB',
  'H3_CENTERASWKT',
  'H3_COMPACT',
  'H3_COVERASH3',
  'H3_COVERASH3STRING',
  'H3_DISTANCE',
  'H3_H3TOSTRING',
  'H3_HEXRING',
  'H3_ISCHILDOF',
  'H3_ISPENTAGON',
  'H3_ISVALID',
  'H3_KRING',
  'H3_KRINGDISTANCES',
  'H3_LONGLATASH3',
  'H3_LONGLATASH3STRING',
  'H3_MAXCHILD',
  'H3_MINCHILD',
  'H3_POINTASH3',
  'H3_POINTASH3STRING',
  'H3_POLYFILLASH3',
  'H3_POLYFILLASH3STRING',
  'H3_RESOLUTION',
  'H3_STRINGTOH3',
  'H3_TESSELLATEASWKB',
  'H3_TOCHILDREN',
  'H3_TOPARENT',
  'H3_TRY_DISTANCE',
  'H3_TRY_POLYFILLASH3',
  'H3_TRY_POLYFILLASH3STRING',
  'H3_TRY_VALIDATE',
  'H3_UNCOMPACT',
  'H3_VALIDATE',
  'HASH',
  'HEX',
  'HISTOGRAM_NUMERIC',
  'HLL_SKETCH_AGG',
  'HLL_SKETCH_ESTIMATE',
  'HLL_UNION',
  'HLL_UNION_AGG',
  'HOUR',
  'HYPOT',
  'IF',
  'IFF',
  'IFNULL',
  'INITCAP',
  'INLINE',
  'INLINE_OUTER',
  'INPUT_FILE_BLOCK_LENGTH',
  'INPUT_FILE_BLOCK_START',
  'INPUT_FILE_NAME',
  'INSTR',
  'INT',
  'IS_ACCOUNT_GROUP_MEMBER',
  'IS_MEMBER',
  'IS_VARIANT_NULL',
  'ISNAN',
  'ISNOTNULL',
  'ISNULL',
  'JAVA_METHOD',
  'JSON_ARRAY_LENGTH',
  'JSON_OBJECT_KEYS',
  'JSON_TUPLE',
  'KURTOSIS',
  'LAG',
  'LAST',
  'LAST_DAY',
  'LAST_VALUE',
  'LCASE',
  'LEAD',
  'LEAST',
  'LEFT',
  'LEN',
  'LENGTH',
  'LEVENSHTEIN',
  'LIST_SECRETS',
  'LN',
  'LOCATE',
  'LOG',
  'LOG10',
  'LOG1P',
  'LOG2',
  'LOWER',
  'LPAD',
  'LTRIM',
  'LUHN_CHECK',
  'MAKE_DATE',
  'MAKE_DT_INTERVAL',
  'MAKE_INTERVAL',
  'MAKE_TIMESTAMP',
  'MAKE_YM_INTERVAL',
  'MAP',
  'MAP_CONCAT',
  'MAP_CONTAINS_KEY',
  'MAP_ENTRIES',
  'MAP_FILTER',
  'MAP_FROM_ARRAYS',
  'MAP_FROM_ENTRIES',
  'MAP_KEYS',
  'MAP_VALUES',
  'MAP_ZIP_WITH',
  'MASK',
  'MAX',
  'MAX_BY',
  'MD5',
  'MEAN',
  'MEDIAN',
  'MIN',
  'MIN_BY',
  'MINUTE',
  'MOD',
  'MODE',
  'MONOTONICALLY_INCREASING_ID',
  'MONTH',
  'MONTHS_BETWEEN',
  'NAMED_STRUCT',
  'NANVL',
  'NEGATIVE',
  'NEXT_DAY',
  'NOW',
  'NTH_VALUE',
  'NTILE',
  'NULLIF',
  'NVL',
  'NVL2',
  'OCTET_LENGTH',
  'OVERLAY',
  'PARSE_JSON',
  'PARSE_URL',
  'PERCENT_RANK',
  'PERCENTILE',
  'PERCENTILE_APPROX',
  'PERCENTILE_CONT',
  'PERCENTILE_DISC',
  'PI',
  'PMOD',
  'POSEXPLODE',
  'POSEXPLODE_OUTER',
  'POSITION',
  'POSITIVE',
  'POW',
  'POWER',
  'PRINTF',
  'QUARTER',
  'RADIANS',
  'RAISE_ERROR',
  'RAND',
  'RANDN',
  'RANDOM',
  'RANDSTR',
  'RANK',
  'REDUCE',
  'REFLECT',
  'REGEXP_COUNT',
  'REGEXP_EXTRACT',
  'REGEXP_EXTRACT_ALL',
  'REGEXP_INSTR',
  'REGEXP_REPLACE',
  'REGEXP_SUBSTR',
  'REGR_AVGX',
  'REGR_AVGY',
  'REGR_COUNT',
  'REGR_INTERCEPT',
  'REGR_R2',
  'REGR_SLOPE',
  'REGR_SXX',
  'REGR_SXY',
  'REGR_SYY',
  'REPEAT',
  'REPLACE',
  'REVERSE',
  'RIGHT',
  'RINT',
  'ROUND',
  'ROW_NUMBER',
  'RPAD',
  'RTRIM',
  'SCHEMA_OF_CSV',
  'SCHEMA_OF_JSON',
  'SCHEMA_OF_JSON_AGG',
  'SCHEMA_OF_VARIANT',
  'SCHEMA_OF_VARIANT_AGG',
  'SCHEMA_OF_XML',
  'SEC',
  'SECOND',
  'SECRET',
  'SENTENCES',
  'SEQUENCE',
  'SESSION_USER',
  'SESSION_WINDOW',
  'SHA',
  'SHA1',
  'SHA2',
  'SHIFTLEFT',
  'SHIFTRIGHT',
  'SHIFTRIGHTUNSIGNED',
  'SHUFFLE',
  'SIGN',
  'SIGNUM',
  'SIN',
  'SINH',
  'SIZE',
  'SKEWNESS',
  'SLICE',
  'SMALLINT',
  'SOME',
  'SORT_ARRAY',
  'SOUNDEX',
  'SPACE',
  'SPARK_PARTITION_ID',
  'SPLIT',
  'SPLIT_PART',
  'SQL_KEYWORDS',
  'SQRT',
  'STACK',
  'STARTSWITH',
  'STD',
  'STDDEV',
  'STDDEV_POP',
  'STDDEV_SAMP',
  'STR_TO_MAP',
  'STRING',
  'STRUCT',
  'SUBSTR',
  'SUBSTRING',
  'SUBSTRING_INDEX',
  'SUM',
  'TAN',
  'TANH',
  'TIMEDIFF',
  'TIMESTAMP',
  'TIMESTAMP_MICROS',
  'TIMESTAMP_MILLIS',
  'TIMESTAMP_SECONDS',
  'TIMESTAMPADD',
  'TIMESTAMPDIFF',
  'TINYINT',
  'TO_AVRO',
  'TO_BINARY',
  'TO_CHAR',
  'TO_CSV',
  'TO_DATE',
  'TO_JSON',
  'TO_NUMBER',
  'TO_TIMESTAMP',
  'TO_UNIX_TIMESTAMP',
  'TO_UTC_TIMESTAMP',
  'TO_VARCHAR',
  'TRANSFORM',
  'TRANSFORM_KEYS',
  'TRANSFORM_VALUES',
  'TRANSLATE',
  'TRIM',
  'TRUNC',
  'TRY_ADD',
  'TRY_AES_DECRYPT',
  'TRY_AVG',
  'TRY_CAST',
  'TRY_DIVIDE',
  'TRY_ELEMENT_AT',
  'TRY_MOD',
  'TRY_MULTIPLY',
  'TRY_PARSE_JSON',
  'TRY_REFLECT',
  'TRY_SECRET',
  'TRY_SUBTRACT',
  'TRY_SUM',
  'TRY_TO_BINARY',
  'TRY_TO_NUMBER',
  'TRY_TO_TIMESTAMP',
  'TRY_URL_DECODE',
  'TRY_VARIANT_GET',
  'TRY_ZSTD_DECOMPRESS',
  'TYPEOF',
  'UCASE',
  'UNBASE64',
  'UNHEX',
  'UNIFORM',
  'UNIX_DATE',
  'UNIX_MICROS',
  'UNIX_MILLIS',
  'UNIX_SECONDS',
  'UNIX_TIMESTAMP',
  'UPPER',
  'URL_DECODE',
  'URL_ENCODE',
  'USER',
  'UUID',
  'VAR_POP',
  'VAR_SAMP',
  'VARIANCE',
  'VARIANT_GET',
  'VECTOR_SEARCH',
  'VERSION',
  'WEEKDAY',
  'WEEKOFYEAR',
  'WIDTH_BUCKET',
  'WINDOW',
  'WINDOW_TIME',
  'XPATH',
  'XPATH_BOOLEAN',
  'XPATH_DOUBLE',
  'XPATH_FLOAT',
  'XPATH_INT',
  'XPATH_LONG',
  'XPATH_NUMBER',
  'XPATH_SHORT',
  'XPATH_STRING',
  'XXHASH64',
  'YEAR',
  'ZIP_WITH',
  'ZSTD_COMPRESS',
  'ZSTD_DECOMPRESS',
];

export const TABLE_VALUED_FUNCTION_NAMES: string[] = [
  'CLOUD_FILES_STATE',
  'EVENT_LOG',
  'RANGE',
  'READ_STATE_METADATA',
  'TABLE_CHANGES',
  'VARIANT_EXPLODE',
  'VARIANT_EXPLODE_OUTER',
];
